import apiClient from "../api/client";
import {
  CreateForcedUpsellDto,
  ForcedUpsellDetailDto,
  CreateTriggeredUpsellDto,
  TriggeredUpsellDetailDto
} from "../types/upselltypes";

export const createForcedUpsell = (
  data: CreateForcedUpsellDto
) =>
  apiClient.post("/api/upsell/forced", data);

export const updateForcedUpsell = (
  guid: string,
  data: CreateForcedUpsellDto
) =>
  apiClient.put(`/api/upsell/forced/${guid}`, data);

export const updateForcedStatus = (
  guid: string,
  active: boolean
) =>
  apiClient.patch(
    `/api/upsell/forced/${guid}/status`,
    { active }
  );

export const getUpsellConfig = (storeNumber: string) =>
  apiClient.get("/api/upsell/config", {
    params: { storeNumber }
  });

export const getUpsellById = async (
  guid: string
): Promise<ForcedUpsellDetailDto> => {
  const res = await apiClient.get<ForcedUpsellDetailDto>(
    `/api/upsell/${guid}`
  );
  return res.data;
};

export const searchForcedUpsells = async (query: any) => {
  const res = await apiClient.post(
    "/api/upsell/forced/search",
    query
  );
  return res.data;
};

export const createTriggeredUpsell = (
  data: CreateTriggeredUpsellDto
) => apiClient.post("/api/upsell/triggered", data);

export const updateTriggeredUpsell = (
  guid: string,
  data: CreateTriggeredUpsellDto
) => apiClient.put(`/api/upsell/triggered/${guid}`, data);

export const updateTriggeredStatus = (
  guid: string,
  active: boolean
) =>
  apiClient.patch(`/api/upsell/triggered/${guid}/status`, { active });

export const getTriggeredById = async (
  guid: string
): Promise<TriggeredUpsellDetailDto> => {
  const res = await apiClient.get<TriggeredUpsellDetailDto>(
    `/api/upsell/triggered/${guid}`
  );
  return res.data;
};

export const searchTriggeredUpsells = async (query: any) => {
  const res = await apiClient.post(
    "/api/upsell/triggered/search",
    query
  );
  return res.data;
};